import angular from 'angular';

export default angular
	.module('ui.cian.utils.disableOutsideScroll', [])
	.directive('cianUtilsDisableOutsideScroll', () => {
		return {
			restrict: 'A',
			link: (scope, element) => {
				const elementNode = element[0];
				element.bind('wheel', event => {
					const heightDiff = elementNode.offsetHeight - elementNode.clientHeight;
					const maxScrollTop = elementNode.scrollHeight - elementNode.offsetHeight + heightDiff;
					const deltaY = (event.originalEvent && event.originalEvent.deltaY) ? event.originalEvent.deltaY : event.deltaY;

					if ((elementNode.scrollTop === maxScrollTop && deltaY > 0) ||
						elementNode.scrollTop === 0 && deltaY < 0) {
						event.preventDefault();
					}
				});
			}
		};
	})
	.name;
